import { render, staticRenderFns } from "./ReImBurseMent.vue?vue&type=template&id=f6f748fc&scoped=true"
import script from "./ReImBurseMent.vue?vue&type=script&lang=js"
export * from "./ReImBurseMent.vue?vue&type=script&lang=js"
import style0 from "./ReImBurseMent.vue?vue&type=style&index=0&id=f6f748fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f748fc",
  null
  
)

export default component.exports